module.exports = __webpack_public_path__ + "img/gear-fill.f8919205.svg";